/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Public preview for a referral code (link preview only).
 * @export
 * @interface ReferralPreview
 */
export interface ReferralPreview {
    /**
     * Amount (USD) the referred person gets on first qualifying booking. 0 if no cash bonus.
     * @type {number}
     * @memberof ReferralPreview
     */
    giveAmount: number;
    /**
     * Cashback tier (3/5/7 = member/silver/gold) this code grants on signup, or null if none.
     * @type {number}
     * @memberof ReferralPreview
     */
    grantsCashbackTier?: number | null;
}

/**
 * Check if a given object implements the ReferralPreview interface.
 */
export function instanceOfReferralPreview(value: object): value is ReferralPreview {
    if (!('giveAmount' in value) || value['giveAmount'] === undefined) return false;
    return true;
}

export function ReferralPreviewFromJSON(json: any): ReferralPreview {
    return ReferralPreviewFromJSONTyped(json, false);
}

export function ReferralPreviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralPreview {
    if (json == null) {
        return json;
    }
    return {
        
        'giveAmount': json['give_amount'],
        'grantsCashbackTier': json['grants_cashback_tier'] == null ? undefined : json['grants_cashback_tier'],
    };
}

export function ReferralPreviewToJSON(json: any): ReferralPreview {
    return ReferralPreviewToJSONTyped(json, false);
}

export function ReferralPreviewToJSONTyped(value?: ReferralPreview | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'give_amount': value['giveAmount'],
        'grants_cashback_tier': value['grantsCashbackTier'],
    };
}

